import { useGetApiV1SerievideoId } from '@/shared/api/generated';

/**
 * Hook para obter um Vídeo por ID.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serievideo/{id}`.
 * Desabilitado quando `videoId` é `undefined` (tela de criação).
 *
 * @param videoId - ID do vídeo; omitir na criação
 *
 * @example
 * ```tsx
 * const { video, isLoading } = useSerieVideo(videoId);
 * ```
 */
export function useSerieVideo(videoId: number | undefined) {
  const query = useGetApiV1SerievideoId(videoId as number, undefined, {
    query: { enabled: videoId !== undefined },
  });

  return {
    video: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
